import { observable, action, computed } from 'mobx';

export default class FastEntryStore {
  @observable status = null;
  @observable message = null;
  @observable itemId = null;
  @observable isReel = false;
  @observable hasContracts = false;
  @observable selectUrl = null;
  @observable quantity = null;
  @observable quantityStep = null;
  @observable quantityMin = null;
  @observable containerQuantity = null;
  @observable containerQuantitySum = null;
  @observable containerPositionCount = null;
  @observable image = null;
  @observable unit = null;
  @observable price = null;
  @observable stockinfo = null;

  @computed get hasError() {
    if (this.status === null) {
      return null;
    }

    return this.status === 'error';
  }

  @computed get orderable() {
    if (this.status === null) {
      return null;
    }

    return this.status === 'success';
  }

  @computed get notOrderable() {
    return this.orderable === null ? null : !this.orderable;
  }

  @computed get isReelOrHasContracts() {
    return this.isReel || this.hasContracts;
  }

  updateItemInfo(data) {
    this.status = data.status;
    this.quantity = data.quantity;
    this.quantityStep = data.quantity_step;
    this.quantityMin = data.quantity_min;
    this.containerQuantity = data.container_quantity || data.quantity;
    this.containerQuantitySum = data.container_quantity_sum || data.quantity;
    this.containerPositionCount = data.container_position_count;
    this.image = data.image;
    this.unit = data.unit;
    this.price = data.price;
    this.stockinfo = data.stockinfo;
    this.isReel = data.is_reel || false;
    this.hasContracts = data.has_contracts || false;
    this.selectUrl = data.select_url;
    if (this.status === 'success') {
      this.message = data.full_label;
      this.itemId = data.item_id;
    } else {
      this.message = data.reason;
    }
  }

  @action
  fetchItemInfo(url, itemId) {
    return $.ajax({
      url,
      data: {
        item_id: itemId,
      },
      success: this.updateItemInfo.bind(this),
    });
  }

  @action
  clear(resetItemId) {
    this.status = null;
    this.message = null;
    this.itemId = null;
    this.quantity = null;
    this.quantityStep = null;
    this.quantityMin = null;
    this.containerQuantity = null;
    this.containerQuantitySum = null;
    this.containerPositionCount = null;
    this.unit = null;
    this.price = null;
    this.stockinfo = null;
    this.isReel = false;
    this.hasContracts = false;
    this.selectUrl = null;

    if (resetItemId) {
      this.itemId = null;
    }
  }
}
